import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

export const useSchema = () => {
  const { t } = useTranslation();

  return yup.object().shape({
    title: yup.string().required(t('warning.required')),
    additionalCertificate: yup.mixed().required(t('warning.required')),
  });
};
